module.exports = __webpack_public_path__ + "media/img/raport-dane-bcg-1d697614.png";